import { Box, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { TotalizationCard } from './TotalizationCard';

type TotalizationCardsProps = {
  processed: number;
  found: number;
  notFounds: number;
};

export function TotalizationCards({
  processed,
  found,
  notFounds,
}: TotalizationCardsProps) {
  const theme = useTheme<Theme>();
  const paletteMain = theme.palette.primary.main;
  const paletteSuccess = theme.palette.success.main;
  const paletteError = theme.palette.error.main;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        flexWrap: 'wrap',
      }}>
      <TotalizationCard
        title="Total de linhas"
        value={processed.toString()}
        bgColor={paletteMain}
        borderColor={paletteMain}
        color={paletteMain}
      />
      <TotalizationCard
        title="Total de linhas encontradas"
        value={found.toString()}
        bgColor={paletteSuccess}
        borderColor={paletteSuccess}
        color={paletteSuccess}
      />
      <TotalizationCard
        title="Total de linhas não encontradas"
        value={notFounds.toString()}
        bgColor={paletteError}
        borderColor={paletteError}
        color={paletteError}
      />
    </Box>
  );
}
